import React, { createContext } from 'react';
import { wrapDisplayName } from 'recompose';
import pick from 'ramda/src/pick';

export const { Provider, Consumer } = createContext(undefined);

const mapProps = (props, mapper) => {
  if (Array.isArray(mapper)) {
    return pick(mapper, props);
  }

  return mapper(props);
};

export const withRootProps = mapper => (Component) => {
  if (!mapper) {
    throw new Error('mapper param is required in the rootPropsHOC');
  }

  function WithRootProps(props) {
    return (
      <Consumer>
        {rootProps => <Component {...mapProps(rootProps, mapper)} {...props} />}
      </Consumer>
    );
  }

  WithRootProps.displayName = wrapDisplayName(Component, 'withRootProps');

  return WithRootProps;
};
